import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'

export const EndLayout = withFacetContext(
    FacetName.end_layout,
    withFilterContext(FilterName.end_layout, SearchFiltersDropdown, {
        hideLabel: true,
        title: 'End layout',
    })
)
